<script setup>
import { router } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import { ref, watch } from "vue";
import debounce from "lodash/debounce";
import Loading from 'vue-loading-overlay';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const props = defineProps({
    year: String,
    taxInvoices: Object,
    flash: Object,
    user: Object,
});

let taxInvSearch = ref('');
let isLoading = ref(false);
let taxinvoicenumber = ref();
dayjs.extend(advancedFormat);

watch([taxInvSearch], debounce(function (value) {
    router.get('/reports/searchTaxInvoices', { taxinvoicenumber: value }, {
        preserveState: true,
        replace: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
    });
    taxinvoicenumber.value = value;
}, 300));

//function to call excel export url
function exportExcel() {
    window.location.href = '/reports/exportTaxInvoiceReportExcel?taxinvoicenumber=' + taxinvoicenumber.value;
}

</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import 'flatpickr/dist/themes/material_orange.css';
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <AppLayout title="Arrival/Departure List" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <div class="card">
                <div class="card-header border-bottom">
                    <h5 class="card-title">Tax Invoice Report</h5>
                    <small class="text-muted">
                        Enter the tax invoice number in the search field, and this report will display all invoices with
                        numbers greater than the one entered.</small>
                    <div class="row mx-2">
                        <div class="col-sm-12 col-md-4 col-lg-6"></div>
                        <div class="col-sm-12 col-md-8 col-lg-6">
                            <div
                                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-md-end justify-content-center align-items-center flex-sm-nowrap flex-wrap me-1">

                                <div class="w-px-200 pb-3 pb-sm-0 m-2">
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input v-model="taxInvSearch" type="text" class="form-control"
                                                placeholder="Invoice Number">
                                        </label>
                                    </div>
                                </div>

                                <div class="btn-group">
                                    <button type="button" class="btn btn-label-primary dropdown-toggle"
                                        data-bs-toggle="dropdown" aria-expanded="false"><i class="bx bx-export me-sm-2"></i>
                                        Export
                                    </button>
                                    <ul class="dropdown-menu" style="">
                                        <li>
                                            <a class="dropdown-item" @click="exportExcel" target="_blank"><i
                                                    class="bx bxs-file me-2"></i>Excel
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-datatable table-responsive" v-if="taxInvSearch">
                    <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div class="card-header flex-column flex-md-row">
                            <div class="dt-action-buttons text-end pt-3">
                                <div class="dt-buttons">
                                </div>
                            </div>
                        </div>

                        <table class="datatables-basic table border-top dataTable no-footer dtr-column"
                            id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info"
                            style="width: 1390px;">
                            <thead>
                                <tr role="row">
                                    <th>Inv Date</th>
                                    <th>Booking Ref</th>
                                    <th>Tax Invoice</th>
                                    <th>Agent</th>
                                    <th>City</th>
                                    <th>Room Rate</th>
                                    <th>Total Payable</th>
                                    <th>Service Fee</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="odd" v-for="invcs in props.taxInvoices">
                                    <td>{{ dayjs(invcs.invoice_date).format('Do MMMM YYYY') }}</td>
                                    <td>{{ invcs.booking_ref }}</td>
                                    <td>{{ invcs.tax_invoice_no }}</td>
                                    <td>{{ invcs.invoice_to }}</td>
                                    <td>{{ invcs.city }}</td>
                                    <td>{{ invcs.room_rate }}</td>
                                    <td>{{ invcs.total_payable }}</td>
                                    <td>{{ invcs.service_fee }}</td>
                                    <td>{{ invcs.total_amount }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>